"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetRunItemSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const zod_2 = require("../utils/zod");
const traces_1 = require("./traces");
exports.DatasetRunItemSchema = zod_1.default.object({
    id: zod_1.default.string(),
    projectId: zod_1.default.string(),
    datasetRunId: zod_1.default.string(),
    datasetItemId: zod_1.default.string(),
    datasetId: zod_1.default.string(),
    traceId: zod_1.default.string(),
    observationId: zod_1.default.string().nullable(),
    error: zod_1.default.string().nullable(),
    // timestamps
    createdAt: zod_1.default.date(),
    updatedAt: zod_1.default.date(),
    // dataset run fields
    datasetRunName: zod_1.default.string(),
    datasetRunDescription: zod_1.default.string().nullable(),
    datasetRunMetadata: traces_1.MetadataDomain,
    datasetRunCreatedAt: zod_1.default.date(),
    // dataset item fields
    datasetItemInput: zod_2.jsonSchema,
    datasetItemExpectedOutput: zod_2.jsonSchema,
    datasetItemMetadata: traces_1.MetadataDomain,
    datasetItemVersion: zod_1.default.date().nullable(),
});
